import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    CardMedia,
    Grow,
    Paper,
    Tooltip,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import econti from "../resources/econti2.jpg";
import { Link } from "react-router-dom";
import ButtonMailto from "../components/ButtonMailTo/ButtonMailTo";
import EmailIcon from "@mui/icons-material/Email";
import InfoIcon from "@mui/icons-material/Info";
import { useEffect, useState } from "react";
import { RetryOnError } from "../utils/utils";

export const AboutPage = () => {
    const theme = useTheme();
    const mdQuery = useMediaQuery(theme.breakpoints.up("md"));
    const smQuery = useMediaQuery(theme.breakpoints.up("sm"));
    const xsQuery = useMediaQuery(theme.breakpoints.up("xs"));

    const [aboutText, setAboutText] = useState("");

    const fetchAboutText = () => {
        fetch("about.txt")
            .then((res) => res.text())
            .then((result) => {
                setAboutText(result);
            })
            .catch((err) => {
                console.error(`failed receiving data from server ${err}`);
                setTimeout(() => {
                    fetchAboutText();
                }, 5000);
            });
    };

    useEffect(() => {
        RetryOnError(fetchAboutText, 5000);
    }, []);

    return (
        <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "row", pt: 2 }}>
            <Paper sx={mdQuery ? { width: "50%" } : { width: "100%" }}>
                <CardHeader
                    avatar={
                        <CardMedia
                            component="img"
                            height="50%"
                            image={econti}
                            alt="preview image"
                            style={{
                                borderRadius: "50%",
                                width: 100,
                                height: 100,
                                display: "block",
                            }}
                        />
                    }
                    title={"Elena Conti"}
                    titleTypographyProps={{ variant: "h4" }}
                    subheader={
                        <Typography variant="body1" color="text.secondary">
                            Formatrice Coding
                        </Typography>
                    }
                >
                    {/* <CardMedia
                component="img"
                height="50%"
                image={econti}
                alt="preview image"
                style={{
                    backgroundRepeat: "no-repeat",
                    borderRadius: "50%",
                    width: 100,
                    height: 100,
                    display: "block",
                    backgroundPosition: "center",
                    backgroundSize: "2000px"
                }}
            /> */}
                </CardHeader>
                <CardContent>
                    <Typography variant="body1" paragraph sx={{ whiteSpace: "pre-line" }}>
                        {aboutText}
                    </Typography>
                    {/* <Typography variant="body1" paragraph><Link to={"mailto:test@gmail.com"}>test@gmail.com</Link></Typography> */}
                    {/* <Typography variant="body1" paragraph><a href="mailto:test@gmail.com">test@gmail.com</a></Typography> */}
                    <Box sx={{ display: "flex", color: theme.palette.primary.main }}>
                        <EmailIcon sx={{ marginRight: "8px" }} />
                        <Typography variant="body1">steamabileclip@gmail.com</Typography>
                    </Box>
                    <Box sx={{ display: "flex", marginTop: "8px", color: theme.palette.primary.main }}>
                        <EmailIcon sx={{ marginRight: "8px" }} />
                        <Typography variant="body1" sx={{ marginRight: "8px" }}>
                            elenateresaconti@pec.steamabile.it
                        </Typography>
                        <Tooltip
                            placement={smQuery ? "right" : "top"}
                            title="Questa è una PEC, solo altri indirizzi PEC possono inviarvi mail"
                        >
                            <InfoIcon />
                        </Tooltip>
                    </Box>

                    {/* <ButtonMailto label="test@gmail.com" mailto="mailto:test@gmail.com" /> */}
                </CardContent>
            </Paper>
        </Box>
    );
};
